<template>
  <div id="statusManage">
    <nav class="navBox">
      <div class="navContent">
        <div
          v-for="(item, index) in navTitle"
          :key="index"
          :class="{navItem: true, navItemSel: item.isSeleted}"
          @click="navTapAction(item)"
        >
          <router-link class="routerLink" tag="span" :to="item.path">{{item.name}}</router-link>
        </div>
      </div>
    </nav>
    <el-container>
      <router-view></router-view>
    </el-container>
  </div>
</template>
<script>
import pathKey from "@/router/routerKey";

export default {
  name: "statusManage",
  data() {
    return {
      curSelectedNav: {
        type: Object
      },
      navTitle: [
        {
          name: "电量",
          path: pathKey.familyStatusElectricityDetail,
          isSeleted: true
        },
        {
          name: "水量",
          path: pathKey.familyStatusWaterDetail,
          isSeleted: false
        },
        {
          name: "气量",
          path: pathKey.familyStatusGasDetail,
          isSeleted: false
        },
        {
          name: "环境",
          path: pathKey.familyStatusEnvironmentDetail,
          isSeleted: false
        },
        {
          name: "智能",
          path: pathKey.familyStatusSmartEnergyPath,
          isSeleted: false
        }
      ]
    };
  },
  created() {
    this.curSelectedNav = this.navTitle[0];
    this.$router.push(pathKey.familyStatusElectricityDetail);
  },
  methods: {
    navTapAction(navItem) {
      if (navItem.name == this.curSelectedNav.name) {
        return;
      }
      this.curSelectedNav.isSeleted = false;
      navItem.isSeleted = true;
      this.curSelectedNav = navItem;
      return navItem.path;
    }
  }
};
</script>
<style scoped>
#statusManage {
  width: 100%;
  min-height: 100vh;
  background-color: #f7f8fb;
}
.navBox {
  width: 100%;
  height: 80px;
  background-color: #fff;
  color: #999;
  font-size: 20px;
  box-shadow: 0px 0px 5px #ccc;
}
.navContent {
  width: 70%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.navItem {
  width: 100px;
  height: 85px;
}
.navItem:hover {
  cursor: pointer;
}
.routerLink {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.navItemSel {
  background-color: #f7f8fb;
  color: #000;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/familyStatus/statusPages/statusManage.vue